import Flex from '@Components/Bases/Flex';
import FinancialStatementsOneReportEn from './FinancialStatementsOneReportEn';
import FinancialStatementsOneReportTh from './FinancialStatementsOneReportTh';

const FinancialStatementsOneReport = () => {
  return (
    <Flex bgcolor={'white'} p={2} gap={2} flexDirection={'column'}>
      <FinancialStatementsOneReportTh />
      <FinancialStatementsOneReportEn />
    </Flex>
  );
};

export default FinancialStatementsOneReport;
